import React from 'react';

const Golf = ({ size = 24, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="20" r="2"/>
    <path d="M12 18V4"/>
    <path d="M12 4L18 8"/>
  </svg>
);

export default Golf;